module.exports = __webpack_public_path__ + "img/bayern_info.d5b6b13f.png";